/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { subscribeToOffer, getStarsCards, getAllWinners } from "../api";
import {
  scrollToTop,
  tokenSolver,
  stars,
  getFromStorage,
  putInStorage,
  TermsAndConditions,
  privGtmKey,
  privSnack,
  privMemberId,
  slugName,
  drawBalance,
  toggleScrollLock,
} from "../utils";
import { GenericPage } from "./WildCardsPage";
import "./WildCardPage.scss";
import "./Pages.scss";
import {
  CoalitionSpinner,
  CoalitionModal,
  CoalitionButton,
  Snackbar,
  ImgLoader,
  isTokenValid,
} from "./../components";
import { stars_prize, stars_earned, circle_check } from "../pngs";
import {
  sendTag,
  event_properties_106_04,
  event_properties_106_05,
  event_properties_106_06,
  event_properties_106_07,
  event_properties_106_08,
  event_properties_106_09,
  event_properties_106_10,
  event_properties_106_11,
} from "../components/CoalitionGtm";
import { StarsPromoError } from "./ErrorsPage";

export const StarsDetailPage = () => {
  const gtm = localStorage.getItem(privGtmKey);
  const navigate = useNavigate();
  const { promoId } = useParams();
  const [loading, setLoading] = useState(false);
  const [card, updateCard] = useState([]);
  const [snack, updateSnack] = useState(false);

  useEffect(() => {
    if (!isTokenValid()) return navigate("/unauth");
    const setCard = async () => {
      setLoading(true);
      let rawStars = getFromStorage(stars);
      if (!rawStars || snack === "true") {
        await getStarsCards().then((newResponse) => {
          const fixed = Object.values(newResponse);
          putInStorage(stars, fixed);
          rawStars = fixed;
        });
      }
      const current = rawStars.find((i) => i.offer_id === Number(promoId));
      if (!current) return navigate(`/?${tokenSolver()}`);
      await updateCard(current);
      setLoading(false);
      scrollToTop();
    };
    setCard();
  }, [navigate, promoId, snack]);

  useEffect(() => {
    updateSnack(localStorage.getItem(privSnack));
    if (snack !== "true") return;
    setTimeout(() => localStorage.setItem(privSnack, false), 3000);
  }, [snack]);

  const solveNavigation = (origin) =>
    navigate(`/${origin === "page" ? "stars" : ""}?${tokenSolver()}`);

  const enrolled = card.points !== undefined;
  const pts = !enrolled ? null : !card.points ? 0 : card.points;
  const progress = `${pts} estrellas`;
  const sendEvent = (payload) => {
    payload.experience_id = card.offer_id;
    payload.experience_progress = progress;
    sendTag(gtm, payload);
  };

  useEffect(() => {
    if (gtm) sendEvent(event_properties_106_04());
  }, [gtm]);

  return (
    <div className="public-page no-top-padding stars-wild-card-page">
      {loading || !card ? (
        <CoalitionSpinner />
      ) : (
        <GenericPage
          title="Todo sobre las estrellas"
          buttonClicked={() => solveNavigation(origin)}
        >
          <>
            {snack === "true" ? (
              <Snackbar
                label={"¡Felicidades! Ya participas en la dinámica"}
                icon={circle_check}
              />
            ) : null}
            <PagePrebuilt
              card={card}
              subscribeButtonClicked={async () => {
                await subscribeToOffer(card.offer_id).then(() => {
                  localStorage.setItem(privSnack, true);
                  if (gtm) sendEvent(event_properties_106_05());
                  navigate(0);
                });
              }}
              sendEvent={sendEvent}
            />
          </>
        </GenericPage>
      )}
    </div>
  );
};

const winnersByTier = (winner, label_awards, groups) => {
  const {
    member_name,
    member_lastname,
    member_id,
    points_amount,
    offer_name,
    position,
  } = winner;
  const tier = slugName(offer_name);
  if (!groups[tier]) groups[tier] = [];
  if (!groups[tier].strat) groups[tier].strat = offer_name;
  if (!groups[tier].prizes) groups[tier].prizes = [];
  if (!groups[tier].winners) groups[tier].winners = [];
  groups[tier].prizes = label_awards;
  groups[tier].winners.push({
    name: `${member_name} ${member_lastname.charAt(0)}`,
    memberId: member_id,
    balance: points_amount,
    position,
  });
};

const buildTiers = (winners, awards, groups, groupsHaveErrors) => {
  const sorted = winners.sort((a, b) => a.position - b.position);
  /**
   * To match the winners with the prizes
   * offer.awards[i].label === offer.winners[j].offer_name
   * Otherwise wont display winners list
   */
  for (const winner of sorted) {
    const award = awards.find((i) => i.label === winner.offer_name);
    if (!award || !award.label_awards) {
      groupsHaveErrors = true;
      console.error("Winners list not matching against offer awards.");
      break;
    }
    winnersByTier(winner, award.label_awards, groups);
  }
  if (!groupsHaveErrors)
    Object.values(groups).map((c) => (groupsHaveErrors = !c.winners));
};

const PagePrebuilt = ({ card, subscribeButtonClicked, sendEvent }) => {
  const {
    offer_id,
    short_title,
    start_date,
    end_date,
    mobile_image,
    desktop_image,
    points, // if points, enrolled and receiving stars
    title,
    description,
    awards,
    allowed_products,
    // forbidden_products, // Not used yet
    terms_and_conditions,
    privacy_policy,
    winners,
    show_position,
  } = card;
  const [winnersReady, setWinnersReady] = useState(false);
  const enrolled = points !== undefined;
  const stars = !enrolled ? null : !points ? 0 : points;
  const now = new Date(Date.now());
  const canEnrolleDate = new Date(start_date);
  const checkWinners = new Date(end_date);
  const waittingWinners = now >= checkWinners;

  let currentIsWinner = null;
  let groups = {};
  let groupsHaveErrors = false;

  if (winners && winners.length > 0) {
    const currentUser = localStorage.getItem(privMemberId);
    currentIsWinner = winners.find((i) => i.member_id === currentUser);
    buildTiers(winners, awards, groups, groupsHaveErrors);
  }

  useEffect(() => setWinnersReady(!winners || winners.length === 0), [winners]);

  return (
    <>
      {groupsHaveErrors ||
      (!winnersReady && Object.keys(groups).length === 0) ? (
          <StarsPromoError />
        ) : (
          <div className="card-detail-stars">
            <div className="stars-content">
              <ImgLoader
                mobile={mobile_image}
                desktop={desktop_image}
                origin={"StarsDetailPage"}
              />
              {enrolled ? <EnrolledTag points={stars} /> : null}
              {waittingWinners && winnersReady ? (
                <>
                  <div className={"promo-status winner-pending"}>
                    <label>Espera resultado ⏰</label>
                  </div>
                </>
              ) : null}
              {winnersReady ? (
                <ContentInProgress
                  title={title}
                  description={description}
                  awards={awards}
                  short_title={short_title}
                  allowed_products={allowed_products}
                  sendEvent={sendEvent}
                />
              ) : (
                <ContentReleased
                  groups={groups}
                  currentIsWinner={currentIsWinner}
                  enrolled={enrolled}
                  showPosition={show_position}
                  promoId={offer_id}
                  awards={awards}
                />
              )}
              {terms_and_conditions ? (
                <TermsDrawer terms={terms_and_conditions} sendEvent={sendEvent} />
              ) : null}
              {privacy_policy ? (
                <PrivacyDrawer privacy={privacy_policy} sendEvent={sendEvent} />
              ) : null}
              {now <= canEnrolleDate || enrolled || waittingWinners ? null : (
                <div className="sticky-button">
                  <CoalitionButton
                    label="Participar"
                    klass="coalition-button-suscribe-promo"
                    onClickEvent={subscribeButtonClicked}
                  />
                </div>
              )}
            </div>
          </div>
        )}
    </>
  );
};

const EnrolledTag = ({ points = 0 }) => {
  const src = stars_earned.startsWith(".")
    ? stars_earned.substring(1)
    : stars_earned;
  return (
    <div className="enrolled-tag">
      <div className="image-container">
        <img src={src} alt="estrellas acumuladas" className="stars-earned" />
      </div>
      <div className="enrolled-label">
        <div className="enrolled-number">{`${points}`}</div>{" "}
        <div className="enrolled-text">estrellas ganadas</div>
      </div>
    </div>
  );
};

const ContentInProgress = ({
  title,
  description,
  awards,
  short_title,
  allowed_products,
  sendEvent,
}) => {
  return (
    <>
      {title ? <div className="title">{title}</div> : null}
      {description ? <div className="description">{description}</div> : null}
      {awards ? <PrizesDrawer awards={awards} /> : null}
      <StepsDrawer
        shortTitle={short_title ?? title}
        allowedProducts={allowed_products}
        sendEvent={sendEvent}
      />
    </>
  );
};

const PrizesDrawer = ({ awards }) => {
  return (
    <>
      <div className="awards">
        <div className="awards-label">Puedes ganar</div>
        {awards.map((item, idx) => (
          <div key={idx} className="prize">
            <div className="prize-label">
              <img src={stars_prize} alt={"icon"} />
              <label>{item.label}</label>
            </div>
            <div className="prize-values">
              {item.label_awards.map((award, idx) => (
                <div key={idx} className="prize-value">
                  {award}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

const StepsDrawer = ({ shortTitle, allowedProducts, sendEvent, idx = 0 }) => {
  const gtm = localStorage.getItem(privGtmKey);
  const [modal, setModal] = useState();
  const [shown, setShown] = useState(false);

  const toggleModal = (modal = false) => {
    const show = Boolean(modal);
    setShown(show);
    toggleScrollLock();
    if (show && gtm) {
      sendEvent(event_properties_106_06());
      sendEvent(event_properties_106_07());
    }
  };

  return (
    <>
      <div className="how-to">
        <div>¿Cómo participar?</div>
        <div className="steps">
          {shortTitle ? (
            <>
              <div className="step">
                <div className="bullet-number">{++idx}</div>
                <div className="description">
                  {`Registrate a la dinámica "${shortTitle}" desde la app de Mi OXXO`}
                </div>
              </div>
            </>
          ) : null}
          {allowedProducts && allowedProducts.length > 0 ? (
            <>
              <div className="step">
                <div className="bullet-number">{++idx}</div>
                <div className="description">
                  {"Visita el OXXO de tu preferencia y compra:"}
                  <ul className="products-list">
                    {allowedProducts.slice(0, 3).map((product, idx) => (
                      <li key={idx}>{product}</li>
                    ))}
                    {allowedProducts.length > 3 ? (
                      <div
                        onClick={() => toggleModal(true)}
                        onKeyPress={() => toggleModal(true)}
                        role="button"
                        tabIndex={0}
                        className="show-more"
                      >
                        Consulta todos los productos participantes
                      </div>
                    ) : null}
                  </ul>
                  {shown ? (
                    <CoalitionModal
                      modalRef={(n) => setModal(n)}
                      closeModal={() => toggleModal()}
                      onKeyDown={(e) =>
                        e.keyCode === 27 ? toggleModal() : null
                      }
                      onClickOutside={(e) =>
                        modal && modal.contains(e.target) ? null : toggleModal()
                      }
                      title={"Productos participantes"}
                    >
                      <ul className="products-list">
                        {allowedProducts.map((product, idx) => (
                          <li key={idx}>{product}</li>
                        ))}
                      </ul>
                    </CoalitionModal>
                  ) : null}
                </div>
              </div>
            </>
          ) : null}
          <div className="step">
            <div className="bullet-number">{++idx}</div>
            <div className="description">
              Escanea tu tarjeta física o digital{" "}
              <b>Spin Premia u OXXO PREMIA</b> en todas tus compras
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const ContentReleased = ({
  groups,
  currentIsWinner,
  enrolled,
  showPosition,
  promoId,
  awards,
}) => {
  let title = "Esta dinámica terminó";
  let description =
    "Participa en los próximos retos y disfruta miles de experiencias únicas para ti.";
  let label = "Listado de las personas que ganaron:";
  if (enrolled) {
    if (currentIsWinner) {
      title = "¡Felicidades! 🎉 Ganaste en este reto";
      description =
        "Muy pronto te contactaremos por correo electrónico o llamada telefónica.";
      label = showPosition
        ? `Quedaste en el lugar ${currentIsWinner.position}:`
        : label;
    } else {
      title = "Estuviste muy cerca de ganar 😔";
    }
  }

  const [modal, setModal] = useState();
  const [shown, setShown] = useState(false);
  const [allGroups, setAllGroups] = useState({});
  const [groupsHaveErrors, setGroupsHaveErrors] = useState(false);

  const toggleModal = async (modal = false) => {
    if (modal) {
      const allWinners = await getAllWinners(promoId);
      const { member_offers } = allWinners;
      let tmpAllGroups = {};
      let tmpGroupsHaveErrors = false;
      buildTiers(member_offers, awards, tmpAllGroups, tmpGroupsHaveErrors);
      setAllGroups(tmpAllGroups);
      setGroupsHaveErrors(tmpGroupsHaveErrors);
    }
    setShown(Boolean(modal));
    toggleScrollLock();
  };

  return (
    <>
      <div className="title">{title}</div>
      <div className="description">{description}</div>
      <div className="label">{label}</div>
      <GroupsToDraw
        groups={groups}
        showPosition={showPosition}
        enrolled={enrolled}
      />
      <div
        className={"button-show-all"}
        onClick={async () => await toggleModal(true)}
        onKeyPress={async () => await toggleModal(true)}
        role="button"
        tabIndex={0}
      >
        Mostrar todos los lugares
      </div>
      {shown ? (
        <CoalitionModal
          modalRef={(n) => setModal(n)}
          closeModal={async () => await toggleModal()}
          onKeyDown={async (e) =>
            e.keyCode === 27 ? await toggleModal() : null
          }
          onClickOutside={async (e) =>
            modal && modal.contains(e.target) ? null : await toggleModal()
          }
          title={"Ganadores"}
        >
          {groupsHaveErrors || Object.keys(allGroups).length === 0 ? (
            <StarsPromoError />
          ) : (
            <GroupsToDraw
              groups={allGroups}
              showPosition={showPosition}
              enrolled={enrolled}
            />
          )}
        </CoalitionModal>
      ) : null}
    </>
  );
};

const GroupsToDraw = ({ groups, showPosition, enrolled }) => (
  <>
    {Object.values(groups).map((group, idx) => (
      <GroupPrize
        key={`${slugName(group.strat)}_${idx}`}
        content={group}
        showPosition={showPosition}
        enrolled={enrolled}
      />
    ))}
  </>
);

const GroupPrize = ({ content = [], showPosition, enrolled }) => {
  const { prizes, strat, winners } = content;
  const currentUser = localStorage.getItem(privMemberId);
  return (
    <>
      <div className="single-prize">
        <Label label={strat} />
        <div className="values">
          {winners.map((winner, idx) => {
            let klass = "row";
            if (idx === winners.length - 1) klass += " last";
            if (winner.memberId === currentUser) klass += " winner";
            return (
              <Row
                key={`row_${idx}`}
                klass={klass}
                member={winner.name}
                balance={winner.balance}
                pos={winner.position}
                prizes={prizes}
                showPos={showPosition}
                enrolled={enrolled}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

const Label = ({ label }) => (
  <div className="label">
    <img src={stars_prize} alt={"icon"} />
    <label>{label}</label>
  </div>
);

const Row = ({ klass, member, balance, pos, prizes, showPos, enrolled }) => {
  const memberLabel = !enrolled
    ? `Lugar ${pos}`
    : showPos
      ? `${pos}. ${member}`
      : member;
  const balanceLabel = `⭐️  ${drawBalance(balance)} estrellas`;
  return (
    <div className={klass}>
      <div className="member-balance">
        <div className="member">{memberLabel}</div>
        <div className="balance">{balanceLabel}</div>
      </div>
      <div className="prizes-list">
        {prizes.map((prize, key) => {
          return (
            <div className="prizes" key={key}>
              {prize}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const LegalsDrawer = ({
  title,
  content,
  label,
  highlighted,
  payloadClick,
  payloadView,
  sendEvent,
}) => {
  const gtm = localStorage.getItem(privGtmKey);
  const [modal, setModal] = useState();
  const [shown, setShown] = useState(false);

  const toggleModal = (modal = false) => {
    const show = Boolean(modal);
    setShown(show);
    toggleScrollLock();
    if (show && gtm) {
      sendEvent(payloadClick);
      sendEvent(payloadView);
    }
  };

  return (
    <>
      <div className="terms-and-conditions">
        {label}{" "}
        <span
          onClick={() => toggleModal(true)}
          onKeyPress={() => toggleModal(true)}
          role="button"
          tabIndex={0}
          className="show-terms"
        >
          {highlighted}
        </span>
      </div>
      {shown ? (
        <>
          <CoalitionModal
            modalRef={(n) => setModal(n)}
            closeModal={() => toggleModal()}
            onKeyDown={(e) => (e.keyCode === 27 ? toggleModal() : null)}
            onClickOutside={(e) =>
              modal && modal.contains(e.target) ? null : toggleModal()
            }
            title={title}
          >
            <TermsAndConditions
              terms={content}
              klass="terms-and-conditions-card-stars"
            />
          </CoalitionModal>
        </>
      ) : null}
    </>
  );
};

const TermsDrawer = ({ terms, sendEvent }) => {
  return (
    <LegalsDrawer
      title={"Términos y condiciones"}
      content={terms}
      label={
        "Al participar reconoces ser mayor de edad, así como haber leído y aceptado los"
      }
      highlighted={"Términos y condiciones"}
      payloadClick={event_properties_106_08()}
      payloadView={event_properties_106_09()}
      sendEvent={sendEvent}
    />
  );
};

const PrivacyDrawer = ({ privacy, sendEvent }) => {
  return (
    <LegalsDrawer
      title={"Aviso de privacidad"}
      content={privacy}
      label={"Puedes consultar en cualquier momento nuestro"}
      highlighted={"Aviso de privacidad."}
      payloadClick={event_properties_106_10()}
      payloadView={event_properties_106_11()}
      sendEvent={sendEvent}
    />
  );
};
